module.exports = __webpack_public_path__ + "media/images/official/flow_image-f641e247f353d7a268e55410ad32277b.jpg";